import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { RouterView } from 'mobx-state-router';
import { ToastContainer } from 'react-toastify';
import { observer } from 'mobx-react';
import React from 'react';

const AppTemplate = ({ routerStore, routerMaps }) => {
	return (
		<React.Fragment>
			<DndProvider backend={HTML5Backend}>
				<ToastContainer
					position="bottom-right"
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					rtl={false}
					pauseOnVisibilityChange
					draggable
					pauseOnHover
				/>
				<RouterView routerStore={routerStore} viewMap={routerMaps} />
			</DndProvider>
		</React.Fragment>
	);
};

export default observer(AppTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/AppTemplate.jsx